export default {
  bagFees: 'Podem ser aplicadas taxas de bagagem adicional',
}
